import {
    AbstractDataState,
    hasFetchedSuccessfully,
    useGetContractBasedApiData,
} from '@cp-shared-15/frontend-integration';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { fetchEarlySettlement } from './EarlySettlementSlice';
import { EarlySettlementDataSelector } from './EarlySettlementDataSelector';
import { useContract } from '../contracts/useContract';
import { useMemo } from 'react';
import { EarlySettlementData, getEarlySettlementEndpoint } from 'cpie-common';

export function useEarlySettlement(
    contractNumber: string,
): AbstractDataState<EarlySettlementData, DefaultBusinessMarketApiErrorCode> {
    const contractState = useContract(contractNumber);
    const earlySettlementState = useGetContractBasedApiData(
        contractNumber,
        fetchEarlySettlement,
        EarlySettlementDataSelector,
        getEarlySettlementEndpoint(contractState.data?.encryptedContractNumber ?? ''),
    );

    return useMemo(
        () => ({
            isLoading: contractState.isLoading || earlySettlementState.isLoading,
            hasReceivedResponse: contractState.loadingError
                ? contractState.hasReceivedResponse
                : contractState.hasReceivedResponse && earlySettlementState.hasReceivedResponse,
            failedLoadingAttempts: hasFetchedSuccessfully(contractState)
                ? earlySettlementState.failedLoadingAttempts
                : contractState.failedLoadingAttempts,
            data: earlySettlementState.data,
            loadingError: hasFetchedSuccessfully(contractState)
                ? earlySettlementState.loadingError
                : contractState.loadingError,
        }),
        [contractState, earlySettlementState],
    );
}
